import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger,
  Input,
  Label,
} from '@fluentui/react-components';
import { Edit20Regular } from '@fluentui/react-icons';

import React from 'react';
import { useReportDetailPageStyles } from '../DetailPage.styles';

interface IRenameReportDialogProps {
  handleRenameSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  reportName: string;
}
export const RenameReportDialog = (props: IRenameReportDialogProps) => {
  const { isOpen, setIsOpen, handleRenameSubmit, reportName } = props;

  const classNames = useReportDetailPageStyles();

  return (
    <Dialog open={isOpen} onOpenChange={(_, data) => setIsOpen(data.open)} modalType="non-modal">
      <DialogTrigger>
        <Button appearance="subtle" icon={<Edit20Regular />} />
      </DialogTrigger>
      <DialogSurface>
        <form onSubmit={handleRenameSubmit}>
          <DialogBody>
            <DialogTitle>Rename the report</DialogTitle>

            <DialogContent className={classNames.dialogContentStyle}>
              <Label required htmlFor={'report-name-input'}>
                Report name
              </Label>
              <Input defaultValue={reportName} required id={'report-name-input'} />
            </DialogContent>
            <DialogActions>
              <Button appearance="primary" type="submit">
                Apply
              </Button>
              <DialogTrigger disableButtonEnhancement>
                <Button appearance="secondary">Cancel</Button>
              </DialogTrigger>
            </DialogActions>
          </DialogBody>
        </form>
      </DialogSurface>
    </Dialog>
  );
};
